<template>
    <div class="container-lg">
        <Filters
            :initialFilters="urlParams"
            :tags="tags"
            :categories="categories"
            @filtered="setFilters"
        ></Filters>
        <div id="page-content-wrapper">
            <Search
                :initialSearch="urlParams.search" @text-searched="setSearchText"
            ></Search>
            <MediaList
                v-if="media.length > 0"
                :collection="media"
                @load-more="handleLoadMore"
                :showLoadMore="showLoadMore"
                @downloaded="downloadSelected"
            ></MediaList>
            <PostsList
                v-else
                :posts="posts"
                @load-more="handleLoadMore"
                :showLoadMore="showLoadMore"
                :isLoading="isLoading"
            ></PostsList>
        </div>
    </div>
</template>

<script>
import Filters from "../components/Filters.vue";
import MediaList from "../components/MediaList.vue";
import PostsList from "../components/PostsList.vue";
import Search from "../components/Search.vue";
import Slider from "../components/Slider.vue";
export default {
    components: { Slider, Search, PostsList, Filters, MediaList },
    props: {
        initialPage: Number
    },
    data() {
        return {
            queryModel: "posts",
            posts: [],
            media: [],
            tags: [],
            categories: [],
            searchText: "",
            filters: {},
            urlParams: {...this.$route.query},
            isLoading: false,
            currentPage: this.initialPage,
            nextPageUrl: "",
            showLoadMore: true,
        };
    },
    metaInfo() {
        return { 
            title: this.$route.params.slug,
            meta: [
                { property: "og:title", content: this.$route.params.slug.slice(0, 60) },
            ]
        }
    },
    mounted() {

    },
    created() {
        this.storeUrlParamsInFilters();
        this.loadInitial();
    },
    beforeRouteUpdate(to, from, next) {
        if(to.path !== from.path) {
            this.resetCurrentPage();
            this.isLoading = true;
            this.urlParams = {}; this.filters = {};
            this.queryModel = "posts";
            this.loadInitial(to.params.slug);
        }
        next();
    },
    methods: {
        setFilters: function (filters) {
            this.resetCurrentPage();

            // If set, merge text search with selected filters
            if(typeof this.filters.search !== "undefined") {
                filters.search = this.filters.search;
            };
            this.filters = filters;
            this.urlParams = {}; this.posts = []; this.media = [];

            /**
             * Filters
             */
            if (typeof this.filters.tags !== "undefined" && this.filters.tags.length > 0) {
                this.urlParams.tags = JSON.stringify(this.filters.tags);
            }
            if (typeof this.filters.categories !== "undefined" && this.filters.categories.length > 0) {
                this.urlParams.categories = JSON.stringify(this.filters.categories);
            }
            if (typeof this.filters.types !== "undefined" && this.filters.types.length > 0) {
                this.urlParams.types = JSON.stringify(this.filters.types);
                this.queryModel = 'media';
            } else {
                this.queryModel = 'posts';
            }
            if (typeof this.filters.orientations !== "undefined" && this.filters.orientations.length > 0) {
                this.urlParams.orientations = JSON.stringify(this.filters.orientations);
            }
            if (typeof this.filters.dates !== "undefined" && this.filters.dates.from.length > 0 && filters.dates.to.length > 0) {
                this.urlParams.dates = JSON.stringify(this.filters.dates);
            }
            if (typeof this.filters.search !== "undefined" && this.filters.search != "") {
                this.urlParams.search = this.filters.search;
            }

            if (Object.keys(this.urlParams).length > 0) {
                this[this.queryModel] = [];
                this.isLoading = true;
                axios
                    .get(process.env.MIX_API_URL + `${this.queryModel}/filter?` + new URLSearchParams(this.urlParams).toString())
                    .then((response) => {
                        this[this.queryModel] = response.data.data;
                        this.updateLoadMoreButton(response);
                        this.isLoading = false;
                    });
            } else {
                this.loadInitial();
            }

            this.$router.push({query: this.urlParams, params: { savePosition: true }});
        },
        setSearchText: function (value) {
            if (!value) {
                if(this.urlParams.search) delete this.urlParams.search;
            }
            this.filters.search = value;
            this.setFilters(this.filters);
        },
        loadInitial: function (slug = null) {
            if(this.urlParams.page) delete this.urlParams.page;
            this.isLoading = true;
            this.posts = []; this.media = [];

            let postsUrl;
            if(Object.keys(this.urlParams).length > 0) {
                if(typeof this.urlParams.types !== "undefined" && this.urlParams.types.length != "") {
                    this.queryModel = 'media';
                }
                postsUrl = `${this.queryModel}/filter?` + new URLSearchParams(this.urlParams).toString();
            } else {
                postsUrl = 'posts/' + (slug ?? this.$route.params.slug);
            }

            axios
                .get(
                    process.env.MIX_API_URL + postsUrl
                )
                .then(async (response) => {
                    this[this.queryModel] = response.data.data;
                    this.updateLoadMoreButton(response);
                    this.isLoading = false;
                    
                    /**
                     * Initial Paging
                     */
                     if(this.initialPage != NaN && this.initialPage > 1) {
                        for (let index = 1; index < this.initialPage; index++) {
                            await this.loadMore()
                        }
                    }
                });
            axios.get(process.env.MIX_API_URL + "tags/").then((response) => {
                this.tags = response.data.data;
            });
            axios
                .get(process.env.MIX_API_URL + "categories/")
                .then((response) => {
                    this.categories = response.data.data;
                });
        },
        resetCurrentPage: function () {
            this.currentPage = 1;
            this.urlParams.page = this.currentPage;
        },
        handleLoadMore: function () {
            this.currentPage++;
            this.urlParams.page = this.currentPage;
            this.$router.push({query: this.urlParams, params: {savePosition: true}});
            this.loadMore();
        },
        loadMore: async function () {
            this.isLoading = true;
            await axios.get(this.nextPageUrl + '&' + new URLSearchParams(this.urlParams).toString()).then((response) => {
                this.moreItems = response.data.data;
                this[this.queryModel] = this[this.queryModel].concat(this.moreItems);
                this.updateLoadMoreButton(response);
                this.isLoading = false;
            });
        },
        updateLoadMoreButton: function (response) {
            if (response.data.links.next !== null) {
                this.nextPageUrl = response.data.links.next;
                this.showLoadMore = true;
            } else {
                this.nextPageUrl = null;
                this.showLoadMore = false;
            }
        },
        downloadSelected: function ({uuids, conversion}) {
            this.selectedItems = uuids;
            let urlParams = "";
            if (this.selectedItems.length > 0) {
                urlParams = urlParams.concat(
                    "&uuids=" + JSON.stringify(this.selectedItems)
                );
            }
            if (conversion !== '') {
                urlParams = urlParams.concat(
                    "&conversion=" + conversion
                );
            }
            window.location.href =
                process.env.MIX_API_URL + "media/download?" + urlParams;
        },
        storeUrlParamsInFilters: function () {
            // Check if urlParams exist
            if (Object.keys(this.urlParams).length > 0) {
                // Iterate through each key in urlParams and update filters
                for (const key in this.urlParams) {
                    if (Object.hasOwnProperty.call(this.urlParams, key)) {
                        // Check if the key exists in filters
                        //if (this.filters.hasOwnProperty(key)) {
                            // Parse JSON if necessary (e.g., for tags, categories, etc.)
                            if (['tags', 'categories', 'types', 'orientations', 'dates'].includes(key)) {
                                this.filters[key] = JSON.parse(this.urlParams[key]);
                            } else {
                                this.filters[key] = this.urlParams[key];
                            }
                        //}
                    }
                }
            }
        },
    },
};
</script>
